export default function checkAccess(name: string, propsUrl?: string) {
    let url = propsUrl || window.location.hash.replace("#", "")
    let cqmDataString = localStorage.getItem('cqmData')
    let cqmData = cqmDataString ? JSON.parse(cqmDataString) : {}
    let positionAccess = cqmData.position_access || {}
    return positionAccess[url] ? positionAccess[url].includes(name) : false
}